import { Injectable } from 'framework/di';

@Injectable
export class DomHelper {
  observeElementInViewport(
    element: HTMLElement | [HTMLElement],
    callback: (element: HTMLElement) => void,
    options?: {
      root?: Element | null;
      rootMargin?: string;
      threshold?: number | number[];
    }
  ) {
    const elements = Array.isArray(element) ? element : [element];
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback(entry.target as HTMLElement);
        }
      });
    }, options);

    elements.forEach((el) => {
      observer.observe(el);
    });

    return () => {
      elements.forEach((el) => {
        observer.unobserve(el);
      });
    };
  }
}
